var _metadata, _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem1Ar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata101"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs99"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, "\n    .st0{fill:#999}.st1{fill:#333}.st2{font-family:'ArialUnicodeMS'}.st3{font-size:15.279px}.st5{fill:#369;fill-opacity:.502}.st6{fill:#fff}.st7{font-size:11.4815px}\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.1 110.5V91.8h-45.7v1.7h44v15.3h-44v1.7h45.7zM542.6 77.3v-1.7H429.1v34.8h113.4v-1.7H430.8V77.3h111.8zM532.5 70v-6.5H367.8V70h164.7m-1.7-4.8v3.1H369.5v-3.1h161.3z",
    id: "path4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 68.3v-3.1H369.5v3.1h161.3z",
    className: "st0",
    id: "path6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M318.9 91.2c.5.8 1.9 3.1 4.1 7 2.4 4.3 4.5 8.1 6.5 11.4h3.6L320.7 88h-6.8l-12.4 21.6h3.6c1.9-3.3 4.1-7.1 6.5-11.4 2.2-3.8 3.6-6.2 4.1-7h3.2z",
    id: "path8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M542.7 110.4v-1.7H201.4v1.7h341.3zM233.8 92.6l-4.1-7-4.1 7h8.2z",
    id: "path10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.8 85.1l-4.8 8.3h11l-5.4-9.5-.8 1.2m-1.8 6.7l2.5-4.4 2.5 4.4h-5zM444.4 76.5l-4.1-7.1-4.1 7.1h8.2z",
    id: "path12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.2 69.3l-5.6 7.9h11.2l-5.6-7.9m-2.7 6.5l2.7-3.9 2.7 3.9h-5.4zM394.6 80.9V69h-5.1v11.9h5.1zM524.9 59.6v-7.5h-5.1v7.5h5.1z",
    id: "path14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M522.5 63.7l4.6-4.6h-9.3l4.7 4.6zM343.6 110.4V97.3h-50.4v13.1h50.4M341.9 99v9.7h-47V99h47z",
    id: "path16"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M341.9 108.7V99h-47v9.7h47z",
    className: "st1",
    id: "path18"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4 82.3h-3.7v10.4h3.7V82.3m-2.1 1.7h.3v7h-.3v-7z",
    id: "path20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M406.6 86.5V80H213.8v6.5h192.8m-1.7-4.8v3.1H215.5v-3.1h189.4z",
    id: "path22"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M404.9 84.8v-3.1H215.5v3.1h189.4z",
    className: "st0",
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0001,0.99990001)",
    id: "text26",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      strokeWidth: 1.0001
    },
    className: "st2 st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 550.63697,60.671654 h -0.72005 q -0.54688,0 -0.96615,-0.145834 -0.41015,-0.154948 -0.83854,-0.483073 -0.38281,0.346354 -0.6836,0.464844 -0.42838,0.164063 -1.2487,0.164063 h -1.12109 q 0,0.838543 -0.40104,1.631513 -0.51954,1.02995 -1.58594,1.631514 -1.33985,0.756512 -3.35418,0.756512 -1.82292,0 -2.78906,-0.638022 -1.0573,-0.701825 -1.0573,-2.151046 0,-0.783856 0.19141,-1.58594 0.19141,-0.802085 0.51953,-1.613285 0.20052,-0.492188 0.69271,-1.513023 l 0.36458,0.164063 q -0.63802,1.312502 -0.84765,2.069014 -0.20052,0.756512 -0.20052,1.385419 0,1.13021 0.80208,1.722659 0.8112,0.583335 2.30599,0.583335 1.75001,0 3.12631,-0.610678 1.71355,-0.756512 1.71355,-2.114588 0,-0.91146 -0.33724,-1.731774 -0.26433,-0.647136 -0.7474,-1.239585 l 0.75651,-1.868493 q 0.45573,0.747397 0.61979,1.321617 0.22787,0.811199 0.22787,2.214848 h 1.12109 q 0.86589,0 1.23048,-0.264324 0.31901,-0.227865 0.31901,-0.701824 0,-0.264323 -0.0365,-0.528647 -0.0273,-0.273438 -0.0911,-0.592449 l 0.36459,-0.546876 0.14583,0.884116 q 0.20052,0.893231 0.53776,1.285159 0.3737,0.437501 1.05729,0.437501 0.20964,0 0.31902,-0.127605 0.11849,-0.136719 0.11849,-0.33724 0,-0.45573 -0.28256,-0.975262 -0.20963,-0.382813 -0.55599,-0.765626 l 0.61068,-0.993492 q 0.42839,0.701825 0.51953,0.957033 0.20052,0.57422 0.20052,1.667972 z",
    style: {
      fontSize: "18.6667px"
    },
    id: "path950"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0001,0.99990001)",
    id: "text28",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    className: "st2 st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 379.80006,105.69657 h -1.34288 v -8.557134 q -0.48493,0.462548 -1.27573,0.925096 -0.78335,0.462548 -1.41003,0.693821 v -1.298118 q 1.12653,-0.529692 1.96956,-1.283197 0.84303,-0.753505 1.19367,-1.462248 h 0.86541 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path968"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 383.23933,100.30267 q 0,-1.93972 0.3954,-3.118471 0.40287,-1.186212 1.18622,-1.82781 0.7908,-0.641599 1.98448,-0.641599 0.88033,0 1.54431,0.358101 0.66398,0.350642 1.09668,1.022082 0.43271,0.66398 0.67891,1.626378 0.24619,0.954938 0.24619,2.581319 0,1.92479 -0.3954,3.111 -0.39541,1.17875 -1.18622,1.82781 -0.78334,0.6416 -1.98447,0.6416 -1.58162,0 -2.48433,-1.13399 -1.08177,-1.36526 -1.08177,-4.44642 z m 1.38018,0 q 0,2.69322 0.62668,3.58847 0.63414,0.8878 1.55924,0.8878 0.92509,0 1.55177,-0.89526 0.63414,-0.89525 0.63414,-3.58101 0,-2.700686 -0.63414,-3.58848 -0.62668,-0.887793 -1.5667,-0.887793 -0.92509,0 -1.47716,0.783347 -0.69383,0.9997 -0.69383,3.692926 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 391.73678,100.30267 q 0,-1.93972 0.39541,-3.118471 0.40286,-1.186212 1.18621,-1.82781 0.7908,-0.641599 1.98448,-0.641599 0.88033,0 1.54431,0.358101 0.66398,0.350642 1.09669,1.022082 0.4327,0.66398 0.6789,1.626378 0.24619,0.954938 0.24619,2.581319 0,1.92479 -0.3954,3.111 -0.39541,1.17875 -1.18621,1.82781 -0.78335,0.6416 -1.98448,0.6416 -1.58162,0 -2.48433,-1.13399 -1.08177,-1.36526 -1.08177,-4.44642 z m 1.38019,0 q 0,2.69322 0.62667,3.58847 0.63414,0.8878 1.55924,0.8878 0.92509,0 1.55177,-0.89526 0.63414,-0.89525 0.63414,-3.58101 0,-2.700686 -0.63414,-3.58848 -0.62668,-0.887793 -1.56669,-0.887793 -0.9251,0 -1.47717,0.783347 -0.69382,0.9997 -0.69382,3.692926 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path972"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 369.86275,103.51066 h -6.54282 v -1.29812 h 5.6774 q -0.52223,-0.79081 -1.19367,-1.37272 -0.67144,-0.58938 -1.81289,-1.268278 l -0.24619,0.231274 -0.88034,-0.67144 q -0.46254,-0.387943 -0.46254,-0.604296 0,-1.283198 0.62667,-2.014322 0.58192,-0.67144 2.00687,-1.208593 l 2.10384,-0.820649 v 1.290658 l -1.55923,0.522231 q -0.93256,0.305879 -1.50701,0.559534 -0.73113,0.320799 -0.73113,0.49239 0,0.17159 0.47747,0.529691 0.29842,0.223814 0.6043,0.447627 1.13399,0.857952 1.97702,1.797973 0.91017,1.00716 1.46225,2.08892 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 363.84216,103.51066 h -8.61682 v -1.29812 h 6.08027 q -0.76097,-0.58937 -1.2832,-0.91763 -0.64906,-0.41033 -1.18621,-0.59684 -0.60429,-0.20889 -1.22351,-0.20889 -0.38048,0 -0.76843,0.0522 0.21635,-0.552072 0.567,-0.887793 0.50731,-0.484929 1.28319,-0.484929 0.76097,0 1.79797,0.746045 0.51477,0.373027 1.6786,1.417487 0.90272,0.81319 1.22352,0.88033 h 0.44762 z m -3.78244,1.61146 -0.58192,1.08176 -1.20859,-0.62668 0.55207,-1.08922 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 355.74758,103.51066 h -0.8878 q -1.23843,0 -2.16353,0.23127 -1.17129,0.29096 -1.17129,0.83557 0,0.49239 0.16413,1.05193 0.17159,0.55953 0.34318,1.13399 0.17905,0.57445 0.17905,1.05192 0,0.2835 -0.0448,0.51477 -0.0373,0.23127 -0.14175,0.6043 -0.19397,-0.61922 -0.38048,-1.23844 -0.3581,-1.17875 -0.52969,-1.78305 -0.26858,-0.95493 -0.26858,-1.1489 0,-0.95494 0.3954,-1.46225 0.40287,-0.51477 1.23098,-0.76097 0.65652,-0.19397 1.97702,-0.32826 -0.47001,-0.47747 -0.58192,-0.56699 -0.38048,-0.29842 -0.76842,-0.29842 -0.2462,0 -0.47001,0.14921 -0.17905,0.11937 -0.43271,0.41032 l -0.34318,-0.21635 q 0.22381,-0.55953 0.50731,-0.89525 0.47001,-0.55208 1.11161,-0.55208 0.46255,0 0.92509,0.34318 0.38049,0.2835 0.77589,0.79081 0.19397,0.2462 0.57446,0.83557 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path978"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.1 176.1v-18.8h-45.7v1.7h44v15.4h-44v1.7h45.7zM542.6 142.8v-1.7H429.1v35h113.4v-1.7H430.8v-31.6h111.8zM532.5 135.5v-6.3H367.8v6.3h164.7m-1.7-4.6v2.9H369.5v-2.9h161.3z",
    id: "path30"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 133.8v-2.9H369.5v2.9h161.3z",
    className: "st0",
    id: "path32"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8 156.8c.5.8 1.9 3.2 4.1 7.1 2.4 4.3 4.5 8.1 6.5 11.4h3.6l-12.2-21.6H314l-12.4 21.6h3.6c1.9-3.3 4.1-7.1 6.5-11.4 2.2-3.9 3.6-6.3 4.1-7.1h3z",
    id: "path34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M542.7 176.1v-1.7H201.4v1.7h341.3zM233.8 158.1l-4.1-7-4.1 7h8.2z",
    id: "path36"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M228.8 150.6l-4.8 8.3h11l-5.4-9.5-.8 1.2m-1.8 6.6l2.5-4.4 2.5 4.4h-5zM479.2 142l-4.1-7.1-4.1 7.1h8.2z",
    id: "path38"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M475.1 134.9l-5.4 7.9h11l-5.6-7.9m-2.6 6.5l2.6-3.7 2.6 3.7h-5.2zM394.6 146.6v-11.9h-5.1v11.9h5.1zM524.9 125.4v-7.6h-5.1v7.6h5.1z",
    id: "path40"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M522.5 129.5l4.6-4.8h-9.3l4.7 4.8zM293.2 163v13.1h50.4V163h-50.4m1.7 11.4v-9.7h47v9.7h-47z",
    id: "path42"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M294.9 164.7v9.7h47v-9.7h-47z",
    className: "st1",
    id: "path44"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4 148h-3.7v10.4h3.7V148m-2.1 1.7h.3v7h-.3v-7z",
    id: "path46"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.8 145.5v6.5h192.7v-6.5H213.8m1.7 4.8v-3.1h189.3v3.1H215.5z",
    id: "path48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 147.2v3.1h189.3v-3.1H215.5z",
    className: "st0",
    id: "path50"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0001,0.99990001)",
    id: "text52",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      strokeWidth: 1.0001
    },
    className: "st2 st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 553.34322,126.17821 h -0.72006 q -0.54687,0 -0.96615,-0.14584 -0.41015,-0.15494 -0.83854,-0.48307 -0.38281,0.34636 -0.68359,0.46484 -0.42839,0.16407 -1.2487,0.16407 h -1.1211 q 0,0.83854 -0.40104,1.63151 -0.51953,1.02995 -1.58594,1.63151 -1.33985,0.75652 -3.35417,0.75652 -1.82292,0 -2.78907,-0.63803 -1.0573,-0.70182 -1.0573,-2.15104 0,-0.78386 0.19141,-1.58594 0.19141,-0.80209 0.51953,-1.61329 0.20052,-0.49218 0.69271,-1.51302 l 0.36459,0.16406 q -0.63803,1.31251 -0.84766,2.06902 -0.20052,0.75651 -0.20052,1.38542 0,1.13021 0.80208,1.72266 0.8112,0.58333 2.306,0.58333 1.75,0 3.1263,-0.61068 1.71355,-0.75651 1.71355,-2.11458 0,-0.91146 -0.33724,-1.73178 -0.26433,-0.64714 -0.7474,-1.23958 l 0.75651,-1.8685 q 0.45573,0.7474 0.6198,1.32162 0.22786,0.8112 0.22786,2.21485 h 1.1211 q 0.86588,0 1.23047,-0.26433 0.31901,-0.22786 0.31901,-0.70182 0,-0.26432 -0.0365,-0.52865 -0.0273,-0.27344 -0.0911,-0.59245 l 0.36459,-0.54687 0.14583,0.88411 q 0.20052,0.89323 0.53776,1.28516 0.3737,0.4375 1.0573,0.4375 0.20963,0 0.31901,-0.1276 0.11849,-0.13672 0.11849,-0.33724 0,-0.45573 -0.28256,-0.97526 -0.20963,-0.38282 -0.55599,-0.76563 l 0.61068,-0.99349 q 0.42839,0.70182 0.51953,0.95703 0.20053,0.57422 0.20053,1.66797 z",
    style: {
      fontSize: "18.6667px"
    },
    id: "path962"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0001,0.99990001)",
    id: "text54",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    className: "st2 st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 381.06361,171.25293 h -1.34288 v -8.55714 q -0.48493,0.46255 -1.27573,0.9251 -0.78335,0.46255 -1.41003,0.69382 v -1.29812 q 1.12653,-0.52969 1.96956,-1.28319 0.84303,-0.75351 1.19367,-1.46225 h 0.86541 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 384.50288,165.85902 q 0,-1.93971 0.3954,-3.11846 0.40287,-1.18621 1.18621,-1.82781 0.79081,-0.6416 1.98448,-0.6416 0.88034,0 1.54432,0.3581 0.66398,0.35064 1.09668,1.02208 0.43271,0.66398 0.6789,1.62638 0.2462,0.95494 0.2462,2.58131 0,1.9248 -0.39541,3.11101 -0.3954,1.17875 -1.18621,1.82781 -0.78334,0.6416 -1.98448,0.6416 -1.58161,0 -2.48433,-1.13399 -1.08176,-1.36526 -1.08176,-4.44643 z m 1.38018,0 q 0,2.69323 0.62668,3.58848 0.63414,0.88779 1.55923,0.88779 0.9251,0 1.55178,-0.89525 0.63413,-0.89525 0.63413,-3.58102 0,-2.70068 -0.63413,-3.58847 -0.62668,-0.88779 -1.5667,-0.88779 -0.92509,0 -1.47717,0.78334 -0.69382,0.9997 -0.69382,3.69292 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 393.00033,165.85902 q 0,-1.93971 0.3954,-3.11846 0.40287,-1.18621 1.18622,-1.82781 0.7908,-0.6416 1.98447,-0.6416 0.88034,0 1.54432,0.3581 0.66398,0.35064 1.09668,1.02208 0.43271,0.66398 0.6789,1.62638 0.2462,0.95494 0.2462,2.58131 0,1.9248 -0.3954,3.11101 -0.39541,1.17875 -1.18622,1.82781 -0.78334,0.6416 -1.98448,0.6416 -1.58161,0 -2.48432,-1.13399 -1.08177,-1.36526 -1.08177,-4.44643 z m 1.38018,0 q 0,2.69323 0.62668,3.58848 0.63414,0.88779 1.55923,0.88779 0.9251,0 1.55178,-0.89525 0.63414,-0.89525 0.63414,-3.58102 0,-2.70068 -0.63414,-3.58847 -0.62668,-0.88779 -1.5667,-0.88779 -0.92509,0 -1.47716,0.78334 -0.69383,0.9997 -0.69383,3.69292 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 371.12629,169.06702 h -6.54281 v -1.29812 h 5.6774 q -0.52223,-0.79081 -1.19367,-1.37272 -0.67144,-0.58938 -1.81289,-1.26828 l -0.24619,0.23127 -0.88034,-0.67144 q -0.46255,-0.38794 -0.46255,-0.60429 0,-1.2832 0.62668,-2.01432 0.58192,-0.67144 2.00686,-1.2086 l 2.10385,-0.82065 v 1.29066 l -1.55923,0.52223 q -0.93256,0.30588 -1.50701,0.55954 -0.73113,0.3208 -0.73113,0.49239 0,0.17159 0.47747,0.52969 0.29842,0.22381 0.6043,0.44763 1.13398,0.85795 1.97702,1.79796 0.91017,1.00716 1.46224,2.08893 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 365.10571,169.06702 h -8.61682 v -1.29812 h 6.08027 q -0.76097,-0.58938 -1.2832,-0.91764 -0.64906,-0.41032 -1.18621,-0.59683 -0.6043,-0.20889 -1.22351,-0.20889 -0.38049,0 -0.76843,0.0522 0.21635,-0.55207 0.56699,-0.88779 0.50731,-0.48493 1.2832,-0.48493 0.76097,0 1.79797,0.74604 0.51477,0.37302 1.6786,1.41749 0.90272,0.81319 1.22351,0.88033 h 0.44763 z m -3.78245,1.61146 -0.58191,1.08176 -1.20859,-0.62668 0.55207,-1.08922 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 357.01112,169.06702 h -0.88779 q -1.23843,0 -2.16353,0.23127 -1.17129,0.29096 -1.17129,0.83557 0,0.49239 0.16413,1.05193 0.17159,0.55953 0.34318,1.13398 0.17905,0.57446 0.17905,1.05193 0,0.28349 -0.0448,0.51477 -0.0373,0.23127 -0.14175,0.60429 -0.19397,-0.61921 -0.38048,-1.23843 -0.35811,-1.17875 -0.5297,-1.78305 -0.26857,-0.95493 -0.26857,-1.14891 0,-0.95493 0.3954,-1.46224 0.40287,-0.51478 1.23098,-0.76097 0.65652,-0.19397 1.97702,-0.32826 -0.47001,-0.47747 -0.58192,-0.56699 -0.38048,-0.29842 -0.76843,-0.29842 -0.24619,0 -0.47,0.14921 -0.17905,0.11936 -0.43271,0.41032 l -0.34318,-0.21635 q 0.22381,-0.55954 0.50731,-0.89526 0.47001,-0.55207 1.11161,-0.55207 0.46254,0 0.92509,0.34318 0.38049,0.2835 0.77589,0.79081 0.19397,0.24619 0.57445,0.83557 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path991"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M247.1 241.7V223h-45.7v1.7h44V240h-44v1.7h45.7zM542.6 208.3v-1.7H429.1v35h113.4v-1.7H430.8v-31.6h111.8zM532.5 201.2v-6.5H367.8v6.5h164.7m-1.7-4.7v3.1H369.5v-3.1h161.3z",
    id: "path56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 199.5v-3.1H369.5v3.1h161.3z",
    className: "st0",
    id: "path58"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8 222.3c.5 1 1.9 3.3 4.1 7.1 2.4 4.3 4.5 8.1 6.5 11.4h3.6l-12.2-21.6H314l-12.4 21.6h3.6c1.9-3.3 4.1-7.1 6.5-11.4 2.2-3.8 3.6-6.2 4.1-7.1h3z",
    id: "path60"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M542.7 241.7V240H201.4v1.7h341.3zM233.8 223.8l-4.1-7.1-4.1 7.1h8.2z",
    id: "path62"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M229.6 215l-5.6 9.7h11l-5.4-9.7m-2.7 8l2.6-4.5 2.6 4.5h-5.2zM513.2 207.5l-4.1-7-4.1 7h8.2z",
    id: "path64"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M514.8 208.4l-.8-1-4.8-6.8-4.8 6.8-.8 1h11.2m-8.2-1.4l2.6-3.8 2.6 3.8h-5.2zM394.6 212.1v-11.9h-5.1v11.9h5.1zM524.9 190.9v-7.5h-5.1v7.5h5.1z",
    id: "path66"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M522.5 195l4.6-4.6h-9.3l4.7 4.6zM293.2 228.6v13.1h50.4v-13.1h-50.4m1.7 11.3v-9.7h47v9.7h-47z",
    id: "path68"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M294.9 230.3v9.7h47v-9.7h-47z",
    className: "st1",
    id: "path70"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M319.4 213.6h-3.7V224h3.7v-10.4m-2.1 1.7h.3v7h-.3v-7z",
    id: "path72"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.7 216.7v-4.6h-191v4.6h191z",
    style: {
      fill: "red"
    },
    id: "path74"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M213.8 211.2v6.3h192.7v-6.3H213.8m1.7 4.6v-2.9h189.3v2.9H215.5z",
    id: "path76"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.5 212.9v2.9h189.3v-2.9H215.5z",
    className: "st0",
    id: "path78"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0001,0.99990001)",
    id: "text80",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      strokeWidth: 1.0001
    },
    className: "st2 st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 551.57819,191.88498 h -0.72006 q -0.54687,0 -0.96615,-0.14583 -0.41015,-0.15495 -0.83854,-0.48308 -0.38281,0.34636 -0.68359,0.46485 -0.42839,0.16406 -1.2487,0.16406 h -1.1211 q 0,0.83854 -0.40104,1.63151 -0.51953,1.02995 -1.58594,1.63152 -1.33985,0.75651 -3.35417,0.75651 -1.82292,0 -2.78907,-0.63802 -1.0573,-0.70183 -1.0573,-2.15105 0,-0.78386 0.19141,-1.58594 0.19141,-0.80208 0.51953,-1.61328 0.20052,-0.49219 0.69271,-1.51303 l 0.36459,0.16407 q -0.63803,1.3125 -0.84766,2.06901 -0.20052,0.75651 -0.20052,1.38542 0,1.13021 0.80208,1.72266 0.8112,0.58333 2.306,0.58333 1.75,0 3.1263,-0.61068 1.71355,-0.75651 1.71355,-2.11458 0,-0.91146 -0.33724,-1.73178 -0.26433,-0.64713 -0.7474,-1.23958 l 0.75651,-1.8685 q 0.45573,0.7474 0.6198,1.32162 0.22786,0.8112 0.22786,2.21485 h 1.1211 q 0.86588,0 1.23047,-0.26432 0.31901,-0.22787 0.31901,-0.70183 0,-0.26432 -0.0365,-0.52865 -0.0273,-0.27343 -0.0912,-0.59244 l 0.36459,-0.54688 0.14583,0.88412 q 0.20052,0.89323 0.53776,1.28515 0.3737,0.43751 1.0573,0.43751 0.20963,0 0.31901,-0.12761 0.11849,-0.13672 0.11849,-0.33724 0,-0.45573 -0.28256,-0.97526 -0.20963,-0.38281 -0.55599,-0.76563 l 0.61068,-0.99349 q 0.42839,0.70183 0.51953,0.95703 0.20053,0.57422 0.20053,1.66798 z",
    style: {
      fontSize: "18.6667px"
    },
    id: "path965"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0001,0.99990001)",
    id: "text82",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    className: "st2 st3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 383.0634,236.90988 h -1.34288 v -8.55713 q -0.48493,0.46254 -1.27574,0.92509 -0.78335,0.46255 -1.41002,0.69382 v -1.29811 q 1.12652,-0.5297 1.96956,-1.2832 0.84303,-0.75351 1.19367,-1.46225 h 0.86541 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path994"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 386.50266,231.51598 q 0,-1.93972 0.39541,-3.11847 0.40286,-1.18621 1.18621,-1.82781 0.79081,-0.6416 1.98448,-0.6416 0.88033,0 1.54431,0.3581 0.66398,0.35064 1.09669,1.02208 0.4327,0.66398 0.6789,1.62638 0.24619,0.95494 0.24619,2.58132 0,1.92479 -0.3954,3.111 -0.3954,1.17876 -1.18621,1.82781 -0.78335,0.6416 -1.98448,0.6416 -1.58162,0 -2.48433,-1.13399 -1.08177,-1.36526 -1.08177,-4.44642 z m 1.38019,0 q 0,2.69322 0.62668,3.58847 0.63413,0.8878 1.55923,0.8878 0.9251,0 1.55177,-0.89526 0.63414,-0.89525 0.63414,-3.58101 0,-2.70069 -0.63414,-3.58848 -0.62667,-0.88779 -1.56669,-0.88779 -0.9251,0 -1.47717,0.78334 -0.69382,0.9997 -0.69382,3.69293 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 395.00012,231.51598 q 0,-1.93972 0.3954,-3.11847 0.40286,-1.18621 1.18621,-1.82781 0.79081,-0.6416 1.98448,-0.6416 0.88033,0 1.54431,0.3581 0.66398,0.35064 1.09669,1.02208 0.43271,0.66398 0.6789,1.62638 0.2462,0.95494 0.2462,2.58132 0,1.92479 -0.39541,3.111 -0.3954,1.17876 -1.18621,1.82781 -0.78335,0.6416 -1.98448,0.6416 -1.58161,0 -2.48433,-1.13399 -1.08176,-1.36526 -1.08176,-4.44642 z m 1.38018,0 q 0,2.69322 0.62668,3.58847 0.63414,0.8878 1.55923,0.8878 0.9251,0 1.55177,-0.89526 0.63414,-0.89525 0.63414,-3.58101 0,-2.70069 -0.63414,-3.58848 -0.62667,-0.88779 -1.56669,-0.88779 -0.9251,0 -1.47717,0.78334 -0.69382,0.9997 -0.69382,3.69293 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 373.12608,234.72397 h -6.54281 v -1.29812 h 5.6774 q -0.52223,-0.79081 -1.19367,-1.37272 -0.67144,-0.58938 -1.81289,-1.26828 l -0.2462,0.23128 -0.88033,-0.67144 q -0.46255,-0.38795 -0.46255,-0.6043 0,-1.2832 0.62668,-2.01432 0.58191,-0.67144 2.00686,-1.20859 l 2.10385,-0.82065 v 1.29065 l -1.55924,0.52224 q -0.93255,0.30587 -1.50701,0.55953 -0.73112,0.3208 -0.73112,0.49239 0,0.17159 0.47747,0.52969 0.29841,0.22381 0.60429,0.44763 1.13399,0.85795 1.97702,1.79797 0.91018,1.00716 1.46225,2.08892 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path1000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 367.1055,234.72397 h -8.61682 v -1.29812 h 6.08026 q -0.76096,-0.58937 -1.28319,-0.91763 -0.64906,-0.41033 -1.18621,-0.59684 -0.6043,-0.20889 -1.22352,-0.20889 -0.38048,0 -0.76842,0.0522 0.21635,-0.55207 0.56699,-0.88779 0.50731,-0.48493 1.2832,-0.48493 0.76096,0 1.79797,0.74604 0.51477,0.37303 1.6786,1.41749 0.90271,0.81319 1.22351,0.88033 h 0.44763 z m -3.78245,1.61146 -0.58192,1.08176 -1.20859,-0.62668 0.55208,-1.08922 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path1002"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 359.01091,234.72397 h -0.88779 q -1.23844,0 -2.16353,0.23127 -1.17129,0.29096 -1.17129,0.83557 0,0.49239 0.16413,1.05193 0.17159,0.55953 0.34318,1.13399 0.17905,0.57445 0.17905,1.05192 0,0.2835 -0.0448,0.51477 -0.0373,0.23127 -0.14174,0.6043 -0.19398,-0.61922 -0.38049,-1.23844 -0.3581,-1.17875 -0.52969,-1.78305 -0.26858,-0.95493 -0.26858,-1.1489 0,-0.95494 0.39541,-1.46225 0.40286,-0.51477 1.23097,-0.76097 0.65652,-0.19397 1.97702,-0.32826 -0.47001,-0.47747 -0.58191,-0.56699 -0.38049,-0.29842 -0.76843,-0.29842 -0.24619,0 -0.47001,0.14921 -0.17905,0.11937 -0.4327,0.41032 l -0.34318,-0.21635 q 0.22381,-0.55953 0.50731,-0.89525 0.47,-0.55208 1.1116,-0.55208 0.46255,0 0.9251,0.34318 0.38048,0.2835 0.77589,0.79081 0.19397,0.2462 0.57445,0.83557 z",
    style: {
      fontSize: "15.279px",
      fontFamily: "ArialUnicodeMS",
      direction: "rtl",
      strokeWidth: 1.0001
    },
    id: "path1004"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M587.7 57.9c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st5",
    id: "path84"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text86",
    style: {
      fontSize: "11.4815px",
      fontFamily: "ArialUnicodeMS",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st6 st2 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 578.39486,71.450127 v -8.626281 q -0.29948,0.299479 -1.01562,0.670572 -0.70964,0.371092 -1.3151,0.520832 v -1.249997 q 0.80078,-0.221354 1.71223,-0.703123 0.91146,-0.48828 1.39974,-0.917967 h 0.48177 v 10.305964 z",
    style: {
      fontSize: "13.3333px"
    },
    id: "path1007"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M587.7 123.7c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6s-3.6 5.3-3.6 8.7 1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st5",
    id: "path88"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text90",
    style: {
      fontSize: "11.4815px",
      fontFamily: "ArialUnicodeMS",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st6 st2 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 580.2373,129.74601 q 0,-0.8138 -0.51432,-1.27604 -0.51432,-0.46875 -1.39973,-0.46875 -0.625,0 -1.26302,0.31901 -0.63802,0.31901 -1.19141,0.91145 v -1.23697 q 0.49479,-0.51432 1.11979,-0.78776 0.63151,-0.27344 1.47786,-0.27344 1.36719,0 2.20052,0.73568 0.83333,0.72916 0.83333,1.97916 0,1.11328 -0.51432,1.92708 -0.50781,0.8138 -1.74479,1.66666 -1.26302,0.87239 -1.6927,1.25 -0.42318,0.3776 -0.59245,0.72265 -0.16927,0.34505 -0.16927,0.83984 h 5.01301 v 1.13281 h -6.34113 v -0.5013 q 0,-0.87239 0.23437,-1.47786 0.24089,-0.61198 0.78776,-1.18489 0.54688,-0.57943 1.70573,-1.38672 1.18489,-0.83333 1.61458,-1.45833 0.43619,-0.63151 0.43619,-1.43228 z",
    style: {
      fontSize: "13.3333px"
    },
    id: "path1010"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M587.7 189.5c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7c2.4 2.4 5.3 3.6 8.7 3.6s6.2-1.2 8.6-3.6c2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st5",
    id: "path92"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.99904951,1.0009514)",
    id: "text94",
    style: {
      fontSize: "11.4815px",
      fontFamily: "ArialUnicodeMS",
      fill: "#ffffff",
      strokeWidth: 0.99905
    },
    className: "st6 st2 st7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 575.61492,201.23895 q 1.03515,0.80078 2.33723,0.80078 1.04167,0 1.64713,-0.50782 0.61198,-0.51432 0.61198,-1.37369 0,-1.91406 -2.74088,-1.91406 h -0.83984 v -1.05468 h 0.80078 q 2.42838,0 2.42838,-1.79687 0,-1.66015 -1.85546,-1.66015 -1.0612,0 -1.9987,0.71614 v -1.20442 q 0.98958,-0.57292 2.31119,-0.57292 1.28906,0 2.07031,0.67708 0.78125,0.67057 0.78125,1.74479 0,1.97916 -2.01822,2.54557 v 0.026 q 1.09374,0.11718 1.72525,0.77473 0.63802,0.65104 0.63802,1.6276 0,1.36068 -0.98307,2.19401 -0.97656,0.83333 -2.60416,0.83333 -1.43229,0 -2.31119,-0.53385 z",
    style: {
      fontSize: "13.3333px"
    },
    id: "path1013"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem1Ar);
export default __webpack_public_path__ + "static/media/item1ar.470ec7e59d02f33efae5e709ca97ffb5.svg";
export { ForwardRef as ReactComponent };